// auditpm-v6
import React, { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const OFF = 'Your access has been turned off. Please contact the Admin.'
  const [error, setError] = useState(() => {
    try { return sessionStorage.getItem('auditpm_access_off') ? OFF : '' } catch (e) { return '' }
  })
  useEffect(() => { try { sessionStorage.removeItem('auditpm_access_off') } catch (e) {} }, [])
  const [loading, setLoading] = useState(false)

  async function handleLogin(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setError(/banned/i.test(error.message) ? OFF : error.message)
    setLoading(false)
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: 'var(--bg2)'
    }}>
      <div style={{ background: 'var(--bg)', border: '0.5px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: 32, width: 360 }}>
        <h1 style={{ marginBottom: 6 }}>AuditPM</h1>
        <p style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 24 }}>Sign in to your account</p>
        {error && <div className="notice notice-warn" style={{ marginBottom: 16 }}>{error}</div>}
        <form onSubmit={handleLogin}>
          <div className="field">
            <label>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
          </div>
          <div className="field">
            <label>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          <button type="submit" className="primary" style={{ width: '100%', marginTop: 8 }} disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  )
}
